// extracted by mini-css-extract-plugin
export var btn = "x_mB s_sr s_r3 d_bz d_bP d_bD d_dw";
export var full = "x_t6 d_w d_H";